import { isEqual } from 'lodash'
import { appAbility } from '~/authorization/ability'

export default defineNuxtRouteMiddleware(async () => {
  const userStore = useUserStore()
  const { hasUser, user } = storeToRefs(userStore)

  await userStore.fetchUser()

  const updatedRules = appAbility(user.value).rules

  if (!isEqual(useNuxtApp().vueApp.config.globalProperties.$ability.rules, updatedRules))
    useNuxtApp().vueApp.config.globalProperties.$ability.update(updatedRules)

  const config = useRuntimeConfig()
  if (config.public.disableAuth === 'true')
    return

  const url = useRequestURL()

  if (!hasUser.value)
    return navigateToLogin(config.public.loginRoute, url)
})
